/**
 * Lifecycle vocabularies shared across the three apps.
 *
 * These live in `shared` rather than in each domain module because the cross-app
 * Executive Dashboard (ADR-0003) counts them side by side, and a dashboard that
 * says "Submitted" for one app and "submitted_for_review" for another is a
 * reporting bug waiting to happen.
 */
/**
 * The record approval lifecycle, common to App 1 reports and App 2 forms.
 *
 * "Sent back" is a real state, not a return to draft: it carries the approver's
 * comments, and App 2 requires those remarks to be mandatory.
 */
export const RECORD_STATUSES = ['draft', 'submitted', 'sent_back', 'approved'];
export const RECORD_STATUS_LABELS = {
    draft: 'Draft',
    submitted: 'Submitted',
    sent_back: 'Sent Back',
    approved: 'Approved',
};
/**
 * Which design token carries each status (ADR-0014). Yellow is the pending/warning
 * colour, turquoise the informational one; neither is decorative here.
 */
export const RECORD_STATUS_TONE = {
    draft: 'neutral',
    submitted: 'info',
    sent_back: 'pending',
    approved: 'positive',
};
/**
 * Soft-delete marker (ADR-0006). Nothing is ever hard-deleted: an archived record
 * keeps its row, its history, and its place in the audit trail, and only drops out
 * of the active uniqueness constraints.
 */
export const LIFECYCLE_STATES = ['active', 'archived'];
/** Audit finding classification (spec §11). App 3 builds on this in phase 4. */
export const FINDING_CLASSIFICATIONS = [
    'conformity',
    'observation',
    'minor_nc',
    'major_nc',
];
export const FINDING_CLASSIFICATION_LABELS = {
    conformity: 'Conformity',
    observation: 'Observation',
    minor_nc: 'Minor NC',
    major_nc: 'Major NC',
};
/** Escalation priorities P1–P6 (spec §11). The matrix itself is configured, not hardcoded. */
export const ESCALATION_PRIORITIES = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6'];
export function isEscalationPriority(value) {
    return typeof value === 'string' && ESCALATION_PRIORITIES.includes(value);
}
export const SUPPORTED_LOCALES = ['en', 'ar'];
/** ADR-0014: direction is derived from locale, never assumed by a component. */
export function directionFor(locale) {
    return locale === 'ar' ? 'rtl' : 'ltr';
}
//# sourceMappingURL=status.js.map